exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".news-body {\n  position: relative;\n  top: 100px;\n}\n.news-body .title {\n  text-align: center;\n}\n.news-body .content {\n  width: 80%;\n  margin: 50px auto;\n}\n.head {\n  position: fixed;\n  z-index: 10;\n  width: 100%;\n  background: #fff;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/project/muyiwang/svn/project-code/trad-portal/src/app/news-detail/news-detail.component.less
// module id = ../../../../../src/app/news-detail/news-detail.component.less
// module chunks = main